import { generateClient } from 'aws-amplify/api';
import { createACTIVITY } from 'graphql/mutations';

const API = generateClient();

/**
 * Log user activity to the audit log
 * @param {Object} params - Parameters for the audit log entry
 * @param {string} params.entity - Entity type (e.g., 'USER', 'CERTIFICATE')
 * @param {string} params.entityID - ID of the entity being acted upon
 * @param {string} params.action - Action being performed (e.g., 'USER_UPDATED', 'USER_DISABLED')
 * @param {string} params.field - Field being modified (optional)
 * @param {string} params.value - New value or details about the change (optional)
 * @param {Object} params.user - User performing the action
 */
export const logActivity = async ({
  entity,
  entityID,
  action,
  field = null,
  value = null,
  user
}) => {
  try {
    const activityInput = {
      entity,
      entityID,
      action,
      field,
      value: typeof value === 'object' ? JSON.stringify(value) : value,
      userID: user?.id || 'system',
      userFullName: user ? `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email : 'System'
    };

    await API.graphql({
      query: createACTIVITY,
      variables: {
        input: activityInput
      }
    });

    console.log('Activity logged:', action, entityID);
  } catch (error) {
    console.error('Error logging activity:', error);
    // Don't throw error to prevent disrupting the main flow
  }
};

// Predefined action types for consistency
export const AUDIT_ACTIONS = {
  // User actions
  USER_CREATED: 'USER_CREATED',
  USER_UPDATED: 'USER_UPDATED',
  USER_ENABLED: 'USER_ENABLED',
  USER_DISABLED: 'USER_DISABLED',
  USER_DELETED: 'USER_DELETED',
  USER_LOGIN: 'USER_LOGIN',
  USER_LOGOUT: 'USER_LOGOUT',
  PASSWORD_RESET: 'PASSWORD_RESET',
  PASSWORD_CHANGED: 'PASSWORD_CHANGED',
  ROLE_CHANGED: 'ROLE_CHANGED',
  STATUS_CHANGED: 'STATUS_CHANGED',
  
  // Certificate actions
  CERTIFICATE_CREATED: 'CERTIFICATE_CREATED',
  CERTIFICATE_UPDATED: 'CERTIFICATE_UPDATED',
  CERTIFICATE_APPROVED: 'CERTIFICATE_APPROVED',
  CERTIFICATE_REJECTED: 'CERTIFICATE_REJECTED',
  CERTIFICATE_DELETED: 'CERTIFICATE_DELETED',
  CERTIFICATE_EXPIRED: 'CERTIFICATE_EXPIRED',
  
  // Organization actions
  ORGANIZATION_CREATED: 'ORGANIZATION_CREATED',
  ORGANIZATION_UPDATED: 'ORGANIZATION_UPDATED',
  ORGANIZATION_DELETED: 'ORGANIZATION_DELETED',
  
  // Document actions
  DOCUMENT_UPLOADED: 'DOCUMENT_UPLOADED',
  DOCUMENT_DELETED: 'DOCUMENT_DELETED',
  DOCUMENT_SCANNED: 'DOCUMENT_SCANNED',
  
  // Comment actions
  COMMENT_CREATED: 'COMMENT_CREATED',
  COMMENT_UPDATED: 'COMMENT_UPDATED',
  COMMENT_DELETED: 'COMMENT_DELETED',
  
  // Notification actions
  NOTIFICATION_SENT: 'NOTIFICATION_SENT',
  NOTIFICATION_READ: 'NOTIFICATION_READ',
  
  // Export actions
  DATA_EXPORTED: 'DATA_EXPORTED',
  REPORT_GENERATED: 'REPORT_GENERATED'
};

// Helper function to format value changes
export const formatValueChange = (oldValue, newValue) => {
  return JSON.stringify({ from: oldValue, to: newValue });
};